import React, { Component } from 'react';

import '../styles/pages/spend.scss';
import intl from 'react-intl-universal';
import AOS from "aos";
import { initAnimations } from '../assets/files/animations';
import Navbar from '../components/navbar/navbar';
import NavbarMobile from '../components/navbar/navbarMobile';
import Footer from '../components/footer';

import SpendNo from '../components/blocks/contentContainers/spend/spendNo.component';
import SpendGooglePay from '../components/blocks/contentContainers/spend/spendGooglePay.component';
import SpendApplePay from '../components/blocks/contentContainers/spend/spendApplePay.component';

import imgHeader from '../assets/images/spend/header.png';
import imgCard from '../assets/images/spend/card.png';

class Spend extends Component {
  componentDidMount() {
    AOS.init(initAnimations);
  }

  render() {
    return (
        <div className="container" style={{ justifyContent: 'space-evenly' }}>
          <Navbar/>
          <NavbarMobile/>

          <section className="page-section section-header">
            <div>
              <article data-aos="fade-right">
                <h1>
                  {intl.getHTML('page.Spend.Header.h')}
                </h1>
                <p>
                  {intl.getHTML('page.Spend.Header.p')}
                </p>
              </article>
            </div>

            <div>
              <img src={imgHeader} alt="" loading="lazy" data-aos="fade-left"/>
            </div>
          </section>


          <section className="page-section green-section section-card">
            <div>
              <img src={imgCard} alt="" loading="lazy" data-aos="fade-right"/>
            </div>

            <div>
              <article data-aos="fade-left">
                <h2>
                  {intl.getHTML('page.Spend.Card.h')}
                </h2>
                <p>
                  {intl.getHTML('page.Spend.Card.p')}
                </p>
              </article>
            </div>
          </section>


          <SpendApplePay/>
          <SpendGooglePay/>
          <SpendNo/>
          <Footer/>
        </div>
    );
  }
}

export default Spend;
